import reduceReducers from 'reduce-reducers';

import { combineReducers } from 'utils/combineReducers';
import { INPUT, DETALIZATION_PAGE_ACTIONS } from './constants';
import detalizationPersonalDataReducer, { detalizationPersonalDataInitialState } from './personalDataStore/reducer';
import periodSelectionReducer, { periodSelectionInitialState } from './periodSelection/reducer';
import detalizationReportReducer, { detalizationReportInitialState } from './detalizationReport/reducer';
import regularDetalizationReportReducer, { regularDetalizationReportInitialState } from './regularDetalizationReport/reducer';
import expensesReducer, { expensesInitialState } from './expensesData/reducer';
import paymentsReducer, { paymentsInitialState } from './paymentsData/reducer';
import expensesPrepaidReducer, { prepaidInitialState } from './expensesPrepaidData/reducer';

const initialState = {
  expenses: { ...expensesInitialState },
  personalData: { ...detalizationPersonalDataInitialState },
  detalizationReport: { ...detalizationReportInitialState },
  periodSelection: { ...periodSelectionInitialState },
  regularDetalizationReport: { ...regularDetalizationReportInitialState },
  payments: { ...paymentsInitialState },
  expensesPrepaid: { ...prepaidInitialState },
  internetPeriod: {
    start: 1,
    end: new Date(),
    isDirty: false,
    isValid: true,
  },
  period: {
    start: new Date(),
    end: new Date(),
    isDirty: false,
    isValid: true,
  },
  internetStats: {
    isFetching: false,
    error: null,
  },
  cashflowStats: {
    isFetching: false,
    error: null,
  },
  invoices: {
    isEmpty: false,
    currentPeriod: null,
    invoicePeriods: null,
    isFetching: true,
    isSending: false,
    sendingError: null,
    error: null,
  },
};

const detalizationNew = (state = initialState, action) => {
  switch (action.type) {
    case INPUT:
      return {
        ...state,
        text: action.text,
      };
    case DETALIZATION_PAGE_ACTIONS.SET_CURRENT_DETALIZATION_MODAL:
      return {
        ...state,
        currentDetalizationModal: action.payload,
      };
    default:
      return state;
  }
};

export default reduceReducers(
  initialState,
  detalizationNew,
  combineReducers(
    'detalizationReport', detalizationReportReducer,
  ),
  combineReducers(
    'regularDetalizationReport', regularDetalizationReportReducer,
  ),
  combineReducers(
    'personalData', detalizationPersonalDataReducer,
  ),
  combineReducers(
    'periodSelection', periodSelectionReducer,
  ),
  combineReducers(
    'expenses', expensesReducer,
  ),
  combineReducers(
    'payments', paymentsReducer,
  ),
  combineReducers(
    'expensesPrepaid', expensesPrepaidReducer,
  ),
);
